import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CASHOUT_DEPOSITS_ROUTE_PATHS } from './config';

export const CASHOUT_DEPOSITS_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-cashout-deposits',
    path: CASHOUT_DEPOSITS_ROUTE_PATHS.cashoutDeposits,
    component: lazy(() => import('./pages/cashout-deposits-page')),
    layout: 'default',
    permissions: { scopes: ['movements-cashout-deposits'] },
    menu: {
      title: 'pages.movements.cashoutDeposits.title',
    },
  },
];
